import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { ThemeOverride, ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import Button from '../../../../../Button';
import ThumbRemove from '../../../../Helper/ThumbRemove';
import s from './StackOverlay.scss';
const StackOverlay = ({ deviation, className, url, biData, onClick, onRemove })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(ThemeOverride, {
        theme: ThemeOptions.DARK,
        className: classnames(s['root'], className)
    }, /*#__PURE__*/ React.createElement(Button, {
        className: s['button'],
        view: "b14",
        fullWidth: false,
        height: "medium",
        href: url,
        onClick: onClick,
        isFakeButton: !url && !onClick,
        biData: biData
    }, t('deviationview.overlay.stack.button')), onRemove && /*#__PURE__*/ React.createElement(ThumbRemove, {
        deviation: deviation,
        onRemove: onRemove,
        className: s['remove']
    }));
};
StackOverlay.displayName = 'StackOverlay';
export default StackOverlay;
